import Types from '../types';

const initialState = [];

export default (reducerState = initialState, action) => {
  switch (action.type) {
    case Types.SET_TAGS:
      return action.payload;
    default:
      return reducerState;
  }
};
